/**
 * What a script that replaced `ServiceWorkerContainer.register` (a crawler, a
 * scanner, a privacy tool) rejects the registration with. The page has no
 * worker then, and nothing in the app is at fault.
 */
const BLOCKED_REGISTRATION_MESSAGE = 'Rejected';

export function isServiceWorkerRegistrationBlocked(error: unknown): boolean {
  return error instanceof Error && error.message === BLOCKED_REGISTRATION_MESSAGE;
}
